<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template #activator="{ on }">
            <div v-on="on">
                <slot></slot>
            </div>
        </template>
        <LabeledCard :label="$t(label)">
            <v-container id="address-selector" class="py-5 px-4" fluid>
                <v-expansion-panels accordion flat v-model="step">
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-text-field
                                dense
                                hide-details
                                readonly
                                clearable
                                @click:clear="clearLocalitySelection"
                                :placeholder="$t('Населённый пункт')"
                                :value="selectedLocality.address_value_abbr"
                                class="pointer header-field"
                            ></v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div>
                                <v-text-field
                                    ref="searchField_0"
                                    placeholder="Начните вводить для поиска"
                                    v-model="localitySearchText"
                                    :loading="loading"
                                    autocomplete="off"
                                    append-icon="mdi-magnify"
                                ></v-text-field>
                                <v-data-table
                                    disable-sort
                                    hide-default-header
                                    :headers="headers"
                                    :items="itemsTranslated(localityItems)"
                                    :options.sync="localityTableOptions"
                                    :server-items-length="localityItemsLength"
                                    :footer-props="{ 'items-per-page-options': [5] }"
                                    @click:row="selectLocality"
                                >
                                    <template #[`item.address_value_abbr`]="{ item }">
                                        {{ item.address_value_abbr || item.address_value }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-text-field
                                dense
                                hide-details
                                readonly
                                clearable
                                @click:clear="clearMicrodistrictSelection"
                                :placeholder="$t('Микрорайон')"
                                :value="selectedMicrodistrict.address_value_abbr"
                                class="pointer header-field"
                            ></v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div>
                                <v-text-field
                                    ref="searchField_1"
                                    placeholder="Начните вводить для поиска"
                                    v-model="microdistrictSearchText"
                                    :loading="loading"
                                    autocomplete="off"
                                    append-icon="mdi-magnify"
                                ></v-text-field>
                                <v-data-table
                                    disable-sort
                                    hide-default-header
                                    :headers="headers"
                                    :items="itemsTranslated(microdistrictItems)"
                                    :options.sync="microdistrictTableOptions"
                                    :server-items-length="microdistrictItemsLength"
                                    :footer-props="{ 'items-per-page-options': [5] }"
                                    @click:row="selectMicrodistrict"
                                >
                                    <template #[`item.address_value_abbr`]="{ item }">
                                        {{ item.address_value_abbr || item.address_value }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-text-field
                                dense
                                hide-details
                                readonly
                                clearable
                                @click:clear="clearStreetSelection"
                                :placeholder="$t('Улица')"
                                :value="selectedStreet.address_value_abbr"
                                class="pointer header-field"
                            ></v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div>
                                <v-text-field
                                    ref="searchField_2"
                                    placeholder="Начните вводить для поиска"
                                    v-model="streetSearchText"
                                    :loading="loading"
                                    autocomplete="off"
                                    append-icon="mdi-magnify"
                                ></v-text-field>
                                <v-data-table
                                    disable-sort
                                    hide-default-header
                                    :headers="headers"
                                    :items="itemsTranslated(streetItems)"
                                    :options.sync="streetTableOptions"
                                    :server-items-length="streetItemsLength"
                                    :footer-props="{ 'items-per-page-options': [5] }"
                                    @click:row="selectStreet"
                                >
                                    <template #[`item.address_value_abbr`]="{ item }">
                                        {{ item.address_value_abbr || item.address_value }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-text-field
                                dense
                                hide-details
                                readonly
                                clearable
                                @click:clear="clearHouseSelection"
                                :placeholder="$t('Дом')"
                                :value="selectedHouse.address_value_abbr"
                                class="pointer header-field"
                            ></v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div>
                                <v-text-field
                                    ref="searchField_3"
                                    placeholder="Начните вводить для поиска"
                                    v-model="houseSearchText"
                                    :loading="loading"
                                    autocomplete="off"
                                    append-icon="mdi-magnify"
                                ></v-text-field>
                                <v-data-table
                                    disable-sort
                                    hide-default-header
                                    :headers="headers"
                                    :items="itemsTranslated(houseItems)"
                                    :options.sync="houseTableOptions"
                                    :server-items-length="houseItemsLength"
                                    :footer-props="{ 'items-per-page-options': [5] }"
                                    @click:row="selectHouse"
                                >
                                    <template #[`item.address_value_abbr`]="{ item }">
                                        {{ item.address_value_abbr || item.address_value }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-text-field
                                dense
                                hide-details
                                readonly
                                clearable
                                @click:clear="clearFlatSelection"
                                :placeholder="$t('Офис/Квартира')"
                                :value="selectedFlat.address_value_abbr"
                                class="pointer header-field"
                            ></v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div>
                                <v-text-field
                                    ref="searchField_4"
                                    placeholder="Начните вводить для поиска"
                                    v-model="flatSearchText"
                                    :loading="loading"
                                    autocomplete="off"
                                    append-icon="mdi-magnify"
                                ></v-text-field>
                                <v-data-table
                                    disable-sort
                                    hide-default-header
                                    :headers="headers"
                                    :items="itemsTranslated(flatItems)"
                                    :options.sync="flatTableOptions"
                                    :server-items-length="flatItemsLength"
                                    :footer-props="{ 'items-per-page-options': [5] }"
                                    @click:row="selectFlat"
                                >
                                    <template #[`item.address_value_abbr`]="{ item }">
                                        {{ item.address_value_abbr || item.address_value }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <div class="d-flex justify-end mt-2">
                    <v-btn outlined color="gray" @click="cancel" class="rounded-btn">Отменить</v-btn>
                    <v-btn
                        depressed
                        color="gray white--text"
                        class="ml-3 text-uppercase"
                        @click="saveSelection"
                        :disabled="!selectedHouse.record_id && !selectedFlat.record_id"
                        >Выбрать</v-btn
                    >
                </div>
            </v-container>
        </LabeledCard>
    </v-dialog>
</template>

<script>
import translate from '@/utils/translate.util';
import LabeledCard from '../ui/LabeledCard';

import AddressService from '@/services/apiRequests/address.service';

import { wait } from '@/utils/index';

export default {
    props: {
        label: {
            default: 'Выбор адреса'
        },
        value: {
            type: Object,
            required: true
        }
    },
    components: { LabeledCard },
    data: () => ({
        dialog: false,
        loading: false,
        step: 0,

        // --------- Locality --------- //
        // choosingLocality: false,
        localitySearchText: '',
        localityItems: [],
        localityItemsLength: 0,
        localityTableOptions: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 5,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        localityFetchOptions: {
            address_rid: 1, // г.Алматы по умолчанию
            searchLine: null,
            itemsPerPage: 5,
            page: 1
        },
        selectedLocality: {},
        // --------- --------- //

        // --------- Microdistrict --------- //
        microdistrictSearchText: '',
        microdistrictItems: [],
        microdistrictItemsLength: 0,
        microdistrictTableOptions: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 5,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        microdistrictFetchOptions: {
            address_rid: null,
            address_parent_rid: 1, // г.Алматы по умолчанию
            searchLine: null,
            itemsPerPage: 5,
            page: 1
        },
        selectedMicrodistrict: {},
        // --------- --------- //

        // --------- Street --------- //
        streetSearchText: '',
        streetItems: [],
        streetItemsLength: 0,
        streetTableOptions: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 5,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        streetFetchOptions: {
            address_rid: null,
            address_parent_rid: 1, // г.Алматы по умолчанию
            searchLine: null,
            itemsPerPage: 5,
            page: 1
        },
        selectedStreet: {},
        // --------- --------- //

        // --------- House --------- //
        houseSearchText: '',
        houseItems: [],
        houseItemsLength: 0,
        houseTableOptions: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 5,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        houseFetchOptions: {
            address_rid: null,
            address_parent_rid: 1, // г.Алматы по умолчанию
            searchLine: null,
            itemsPerPage: 5,
            page: 1
        },
        selectedHouse: {},

        // --------- Flat --------- //
        flatSearchText: '',
        flatItems: [],
        flatItemsLength: 0,
        flatTableOptions: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 5,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [],
            sortDesc: []
        },
        flatFetchOptions: {
            address_rid: null,
            address_parent_rid: 1, // г.Алматы по умолчанию
            searchLine: null,
            itemsPerPage: 5,
            page: 1
        },
        selectedFlat: {}
        // --------- --------- //

        // choosingMicrodistrict: false,
        // choosingStreet: false,
        // choosingHouse: false
    }),
    computed: {
        headers() {
            return [{ text: '', value: 'address_value_abbr', sortable: false }];
        }
    },
    watch: {
        dialog(opened) {
            if (opened) {
                this.clearLocalitySelection();
                this.fetchLocalities();
            }
        },
        value(val) {
            this.selectedHouse = this.step == 4 ? val : this.selectedHouse;
            this.selectedFlat = this.step == undefined ? val : this.selectedFlat;
        },

        async step(val) {
            switch (val) {
                case 1:
                    if (!this.microdistrictItems.length) {
                        this.fetchMicrodistricts();
                    }
                    break;
                case 2:
                    if (!this.streetItems.length) {
                        this.fetchStreets();
                    }
                    break;
                case 3:
                    if (!this.houseItems.length) {
                        this.fetchHouses();
                    }
                    break;
                case 4:
                    if (!this.flatItems.length) {
                        this.fetchFlats();
                    }
                    break;

                default:
                    break;
            }

            if (typeof val === 'undefined') return;
            await wait(100);
            this.$refs[`searchField_${val}`].focus(); // search autofocus
        },
        async localityTableOptions(newOptions) {
            // проверка не даёт отработать идентичный запрос лишний раз
            if (newOptions.page === this.localityFetchOptions.page && newOptions.itemsPerPage === this.localityFetchOptions.itemsPerPage) return;

            this.localityFetchOptions.itemsPerPage = newOptions.itemsPerPage;
            this.localityFetchOptions.page = newOptions.page;

            this.fetchLocalities();
        },

        async localitySearchText(str) {
            // simple debounce
            if (!str || (str && str?.length < 2)) return;
            await wait(1000);
            if (str !== this.localitySearchText) return;

            this.localityFetchOptions = {
                address_rid: null,
                searchLine: str,
                itemsPerPage: this.localityTableOptions.itemsPerPage,
                page: 1
            };
            this.localityTableOptions.page = 1;
            this.fetchLocalities();
        },

        async microdistrictTableOptions(newOptions) {
            // проверка не даёт отработать идентичный запрос лишний раз
            if (newOptions.page === this.microdistrictFetchOptions.page && newOptions.itemsPerPage === this.microdistrictFetchOptions.itemsPerPage) return;

            this.microdistrictFetchOptions.itemsPerPage = newOptions.itemsPerPage;
            this.microdistrictFetchOptions.page = newOptions.page;
            this.fetchMicrodistricts();
        },

        async microdistrictSearchText(str) {
            // simple debounce
            if (!str || (str && str?.length < 2)) return;
            await wait(1000);
            if (str !== this.microdistrictSearchText) return;

            this.microdistrictFetchOptions = {
                ...this.microdistrictFetchOptions,
                searchLine: str,
                itemsPerPage: this.microdistrictTableOptions.itemsPerPage,
                page: 1
            };
            this.microdistrictTableOptions.page = 1;
            this.fetchMicrodistricts();
        },

        async streetTableOptions(newOptions) {
            // проверка не даёт отработать идентичный запрос лишний раз
            if (newOptions.page === this.streetFetchOptions.page && newOptions.itemsPerPage === this.streetFetchOptions.itemsPerPage) return;

            this.streetFetchOptions.itemsPerPage = newOptions.itemsPerPage;
            this.streetFetchOptions.page = newOptions.page;
            this.fetchStreets();
        },

        async streetSearchText(str) {
            // simple debounce
            if (!str || (str && str?.length < 2)) return;
            await wait(1000);
            if (str !== this.streetSearchText) return;

            this.streetFetchOptions = {
                ...this.streetFetchOptions,
                searchLine: str,
                itemsPerPage: this.streetTableOptions.itemsPerPage,
                page: 1
            };

            this.streetTableOptions.page = 1;
            this.fetchStreets();
        },

        async houseTableOptions(newOptions) {
            // проверка не даёт отработать идентичный запрос лишний раз
            if (newOptions.page === this.houseFetchOptions.page && newOptions.itemsPerPage === this.houseFetchOptions.itemsPerPage) return;

            this.houseFetchOptions.itemsPerPage = newOptions.itemsPerPage;
            this.houseFetchOptions.page = newOptions.page;
            this.fetchHouses();
        },

        async houseSearchText(str) {
            // simple debounce
            if (!str) return;
            await wait(1000);
            if (str !== this.houseSearchText) return;

            this.houseFetchOptions = {
                ...this.houseFetchOptions,
                searchLine: str,
                itemsPerPage: this.houseTableOptions.itemsPerPage,
                page: 1
            };

            this.houseTableOptions.page = 1;
            this.fetchHouses();
        },

        async flatTableOptions(newOptions) {
            // проверка не даёт отработать идентичный запрос лишний раз
            if (newOptions.page === this.flatFetchOptions.page && newOptions.itemsPerPage === this.flatFetchOptions.itemsPerPage) return;

            this.flatFetchOptions.itemsPerPage = newOptions.itemsPerPage;
            this.flatFetchOptions.page = newOptions.page;
            this.fetchFlats();
        },

        async flatSearchText(str) {
            // simple debounce
            if (!str) return;
            await wait(1000);
            if (str !== this.flatSearchText) return;

            this.flatFetchOptions = {
                ...this.flatFetchOptions,
                searchLine: str,
                itemsPerPage: this.flatTableOptions.itemsPerPage,
                page: 1
            };

            this.flatTableOptions.page = 1;
            this.fetchFlats();
        }
    },
    methods: {
        clearLocalitySelection() {
            this.selectedLocality = {};
            this.clearMicrodistrictSelection(false);

            this.step = 0;
        },

        clearMicrodistrictSelection(buttonClicked = true) {
            this.selectedMicrodistrict = {};

            if (!buttonClicked) {
                this.microdistrictItems = [];
                this.microdistrictSearchText = '';
                this.microdistrictTableOptions.page = 1; //триггерит новый запрос
            } else {
                this.step = 1;
            }

            this.clearStreetSelection(false);
        },

        clearStreetSelection(buttonClicked = true) {
            this.selectedStreet = {};

            if (!buttonClicked) {
                this.streetItems = [];
                this.streetSearchText = '';
                this.streetTableOptions.page = 1;
                this.streetItems = [];
                this.streetItemsLength = 0;

                this.streetFetchOptions = {
                    address_rid: null,
                    address_parent_rid: this.selectedMicrodistrict?.record_id || this.selectedLocality?.record_id || null,
                    searchLine: null,
                    itemsPerPage: 5,
                    page: 1
                };
            } else {
                this.step = 2;
            }

            this.clearHouseSelection(false);
        },

        clearHouseSelection(buttonClicked = true) {
            this.selectedHouse = {};

            if (!buttonClicked) {
                this.houseItems = [];
                this.houseSearchText = '';
                this.houseTableOptions.page = 1;
                this.houseItems = [];
                this.houseItemsLength = 0;

                this.houseFetchOptions = {
                    address_rid: null,
                    address_parent_rid: this.selectedStreet?.record_id || this.selectedMicrodistrict?.record_id || this.selectedLocality?.record_id || null,
                    searchLine: null,
                    itemsPerPage: 5,
                    page: 1
                };
            } else {
                this.step = 3;
            }

            this.clearFlatSelection(false);
        },

        clearFlatSelection(buttonClicked = true) {
            this.selectedFlat = {};

            if (!buttonClicked) {
                this.flatItems = [];
                this.flatSearchText = '';
                this.flatTableOptions.page = 1;
                this.flatItems = [];
                this.flatItemsLength = 0;

                this.flatFetchOptions = {
                    address_rid: null,
                    address_parent_rid: this.selectedHouse?.record_id || this.selectedLocality?.record_id || null,
                    searchLine: null,
                    itemsPerPage: 5,
                    page: 1
                };
            } else {
                this.step = 4;
            }
        },

        itemsTranslated(items) {
            return translate(items, 'full', this.$i18n.locale);
        },

        async fetchLocalities() {
            try {
                this.loading = true;

                const response = await AddressService.getLocalities(this.localityFetchOptions);

                this.localityItems = response?.isas_addresses || [];
                this.localityItemsLength = response.pagination?.row_count || 0;

                if (this.localityFetchOptions.address_rid === 1) {
                    // г.Алматы по умолчанию
                    this.selectLocality(this.itemsTranslated(this.localityItems[0]));
                }
            } finally {
                this.loading = false;
            }
        },

        async fetchMicrodistricts() {
            try {
                this.loading = true;

                const response = await AddressService.getMicrodistricts(this.microdistrictFetchOptions);

                this.microdistrictItems = response?.isas_addresses || [];
                this.microdistrictItemsLength = response.pagination?.row_count || 0;
            } finally {
                this.loading = false;
            }
        },

        async fetchStreets() {
            try {
                this.loading = true;

                const response = await AddressService.getStreets(this.streetFetchOptions);

                this.streetItems = response?.isas_addresses || [];
                this.streetItemsLength = response.pagination?.row_count || 0;
            } finally {
                this.loading = false;
            }
        },

        async fetchHouses() {
            try {
                this.loading = true;

                const response = await AddressService.getHouses(this.houseFetchOptions);

                this.houseItems = response?.isas_addresses || [];
                this.houseItemsLength = response.pagination?.row_count || 0;
            } finally {
                this.loading = false;
            }
        },

        async fetchFlats() {
            try {
                this.loading = true;

                const response = await AddressService.getFlats(this.flatFetchOptions);

                this.flatItems = response?.isas_addresses || [];
                this.flatItemsLength = response.pagination?.row_count || 0;
            } finally {
                this.loading = false;
            }
        },

        selectLocality(item) {
            this.selectedLocality = item;

            this.microdistrictFetchOptions = {
                ...this.microdistrictFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.streetFetchOptions = {
                ...this.streetFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.clearMicrodistrictSelection(false);
            this.fetchMicrodistricts();

            this.step = 1;
        },
        selectMicrodistrict(item) {
            this.selectedMicrodistrict = item;

            this.streetFetchOptions = {
                ...this.streetFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.houseFetchOptions = {
                ...this.houseFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.clearStreetSelection(false);
            this.fetchStreets();

            this.step = 2;
        },
        selectStreet(item) {
            this.selectedStreet = item;

            this.houseFetchOptions = {
                ...this.houseFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.clearHouseSelection(false);
            this.fetchHouses();

            this.step = 3;
        },

        selectHouse(item) {
            this.selectedHouse = item;

            this.flatFetchOptions = {
                ...this.flatFetchOptions,
                address_parent_rid: item.record_id,
                searchLine: null,
                page: 1
            };

            this.clearFlatSelection(false);
            this.fetchFlats();

            this.step = 4;
        },

        selectFlat(item) {
            this.selectedFlat = item;
            this.step = undefined;
        },

        saveSelection() {
            this.$emit('input', this.selectedFlat?.address_full_name ? this.selectedFlat : this.selectedHouse);
            this.dialog = false;
        },

        cancel() {
            this.dialog = false;
            this.selectedHouse = this.step == 4 ? this.value : this.selectedHouse;
            this.selectedFlat = this.step == undefined ? this.value : this.selectedFlat;
        }
    }
};
</script>

<style lang="scss">
#address-selector {
    .v-expansion-panel {
        margin-bottom: 12px;
        border: 1px solid rgba(0, 0, 0, 0.38);
        border-radius: 4px;
    }
    .v-expansion-panel-header {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 40px;

        .header-field {
            padding-bottom: 4px;
            .v-input__slot:before,
            .v-input__slot:after {
                display: none;
            }

            input::placeholder {
                color: rgba(0, 0, 0, 0.54);
            }

            .v-icon {
                margin-top: 0px;
                color: rgba(0, 0, 0, 0.54);
            }
        }
    }

    .v-expansion-panel-content {
        border-radius: 0 0 4px 4px;
    }

    .v-expansion-panel--active {
        > .v-expansion-panel-header {
            border-bottom: 1px solid rgba(0, 0, 0, 0.38);
        }
    }

    table tr {
        cursor: pointer;
    }
}
</style>
